import { render, staticRenderFns } from "./HomeSettingsExtra.vue?vue&type=template&id=d883b6e8&scoped=true&"
import script from "./HomeSettingsExtra.vue?vue&type=script&lang=js&"
export * from "./HomeSettingsExtra.vue?vue&type=script&lang=js&"
import style0 from "./HomeSettingsExtra.vue?vue&type=style&index=0&id=d883b6e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d883b6e8",
  null
  
)

export default component.exports